import { exemptionTypes } from '../../../services/exemptions';

export default function AknowledgementByExemption({ exemptionType }) {
  switch (exemptionType) {
    case exemptionTypes.medCovidBooster:
    case exemptionTypes.medCovidVax:
    case exemptionTypes.relCovidBooster:
    case exemptionTypes.relCovidVax:
      return (
        <>
          <p>
            I understand that my failure to submit a completed Exemption Request Form, including for example, acceptable medical documentation for a medical exemption, before the end of the designated vaccination period, may result in my request for an exemption being denied.
            <br />
            My signature on this form is my attestation that I am requesting an exemption in good faith and the information I am providing or causing others to provide on my behalf is true and correct. I understand that providing false or misleading information may be grounds for discipline, up to and including discharge.
            <br />
          </p>

          <b>I understand and consent to the following:</b>
          <ul>
            <li>My exemption request will be reviewed by a MedStar Health COVID-19 Vaccine Clinical Advisory Committee for medical exceptions and by Human Resources for religious exemptions.</li>
            <li>
              If the exemption is granted, I will be required to practice alternative safety practices, which will be defined by MedStar Health's executive vice president and chief medical officer based on community prevalence, and may include requirements for distancing, masking, and interval testing, among others. Initial requirements, which are subject to change consistent with OSHA or other public health requirements, are currently as follows:
              <ul>
                <li>
                  Source control, for the safety of other associates, patients, and visitors:
                  <ul>
                    <li>Strict masking (mouth and nose) at all times when on MedStar Health business or inside MedStar Health facilities.</li>
                    <li>
                      Exception is during meal breaks, however:
                      <ul>
                        <li>Cannot eat in breakrooms if others are present.</li>
                        <li>May eat in large spaces such as cafeteria only when maintaining strict 6 ft distance from all others while mask is down.</li>
                        <li>Must replace mask as soon as finished eating.</li>
                      </ul>
                    </li>
                    {exemptionType === exemptionTypes.relCovidVax && <li>Mandatory testing--Frequency will depend on community prevalence, maximum 2 times per week. MedStar Health wellness testing facilities may be utilized</li>}
                  </ul>
                </li>
              </ul>
            </li>

            <li>My leader will be notified if my exemption request is granted.</li>
            <li>My exemption may not be granted if it poses a direct threat to others (i.e., patients, coworkers, or visitors) or if it would otherwise create an undue hardship on MedStar Health.</li>
          </ul>
        </>
      );
    case exemptionTypes.medN95Fit:
    case exemptionTypes.medFluVax:
    case exemptionTypes.relN95Fit:
    case exemptionTypes.relFluVax:
      return (
        <>
          <p>I understand that my failure to submit a completed exemption request form, including for example, acceptable medical documentation for a medical exemption, before the end of the designated vaccination period may result in my request for an exemption being denied.</p>
          <p>My signature on this form is my attestation that I am requesting an exemption in good faith and the information I am providing or causing others to provide on my behalf is true and correct. I understand that providing false or misleading information may be grounds for discipline, up to and including termination.</p>

          <b>I understand and consent to the following:</b>
          <ul className='mt-2'>
            <li>My exemption request will be reviewed by Human Resources and/or Occupational Health.</li>
            <li>My leader may also be consulted as part of the exemption review process.</li>
            <li>My leader will be notified if my exemption request is granted.</li>
            <li>My exemption may not be granted if it would pose a direct threat to others (i.e., patients, coworkers, or visitors) or if it would otherwise create an undue hardship on MedStar Health.</li>
          </ul>
        </>
      );
    default:
      return null;
  }
}
